/**
 * Shared debounce hook for the discount engine screens (phase 6b, Task 7b
 * tidy). Hoisted out of `promotions/PromotionsList.tsx` and
 * `promotions/CodesTab.tsx`, which each had an identical private copy.
 */
import { useEffect, useState } from 'react';

export const useDebounced = <T,>(value: T, ms: number): T => {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
};
